import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import logo from "../../Assets/VMD LOGO.png"
const Footer = () => {
  return (
    <footer className="bg-[#fdfbf0] text-gray-800 text-sm">
      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-4 gap-8  ">
        
        {/* About Section */}
        <div>
          <h2 className="font-semibold text-center text-lg mb-4">VMD Developers and Promoters</h2>
          <p className="text-sm text-justify">
          Established in 2022, VMD Developers and Promoters is proud to be the first ISO-certified real estate company. With a commitment to setting new benchmarks in quality and trust, the company is currently developing landmark projects across 12 major cities in India, covering over 18.58 million square meters. VMD Developers and Promoters is recognized for bringing innovation, excellence, and integrity to the real estate industry.
          </p>
          <div className="mt-4">
            <span className="font-semibold">FOLLOW US ON</span>
            <div className="flex space-x-4 mt-2 text-xl">
              <FaFacebookF />
              <FaTwitter />
              <FaInstagram />
              <FaYoutube />     
            </div>
          </div>
        </div>

        {/* Work With Us */}
        <div>
          <h2 className="font-semibold text-lg mb-4">WORK WITH US</h2>
          <ul className="space-y-2">
            <li><a href="#" className="hover:text-blue-600">ENQUIRE</a></li>
            <li><a href="#" className="hover:text-blue-600">SCHEDULE A SITE VISIT</a></li>
          </ul>
            {/* Our Story */}
        <div className='mt-4'>
          <h2 className="font-semibold text-lg  mb-2">OUR STORY</h2>
          <ul className="space-y-2">
            <li><a href="#" className="hover:text-blue-600">About Us</a></li>
            {/* <li><a href="#" className="hover:text-blue-600">Management</a></li>
            <li><a href="#" className="hover:text-blue-600">Sustainability</a></li>
            <li><a href="#" className="hover:text-blue-600">Design</a></li> */}
          </ul>

        </div>
        </div>

      

        {/* Projects / Media */}
        <div>
          <h2 className="font-semibold text-lg mb-4">PROJECTS</h2>
          <ul className="space-y-2 mb-6">
            <li><a href="#" className="hover:text-blue-600">Residential</a></li>
            <li><a href="#" className="hover:text-blue-600">Commercial</a></li>
          </ul>
          <h2 className="font-semibold text-lg mb-4">ADDRESS</h2>
          <ul className="space-y-2">
            <li><a  className="hover:text-blue-600">A kaspa, to, Ahmedi Nagar,</a></li>
            <li><a href="#" className="hover:text-blue-600">Somalapuram, Ambur, </a></li>
            <li><a href="#" className="hover:text-blue-600">Tamil Nadu - 635802</a></li>
          </ul>
        </div>

        {/* Investor Section */}
        <div>
          <h2 className="font-semibold text-lg mb-4">LOCATION</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.6072530900183!2d78.7192584745441!3d12.803986118532075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad097cda0c65ed%3A0xf98a3fef51978ca9!2sRDS%20Enclave!5e0!3m2!1sen!2sin!4v1747054026892!5m2!1sen!2sin"
            width="100%"
            height="200"
            
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
            className="rounded   shadow-md"
          >
            
          </iframe>
 
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-300 mt-6 py-4 text-center text-xs text-gray-600 flex flex-col md:flex-row justify-between items-center px-4 max-w-7xl mx-auto">
                   <img src={logo} alt="Logo" className=" md:w-[15%] md:h-[15%] w-[30%] h-[30%]  object-cover   " />

        <p>Copyright © 2025. VMD  Developers Properties</p>
        <div className="space-x-4 mt-2 md:mt-0">
          <a href="#" className="hover:underline">Disclaimer</a>
          <a href="#" className="hover:underline">Sitemap</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
